import { isObject, isNull, isBoolean, isString } from 'lodash';

let nameSpace = '@TPP_PORTAL';

export const setKey = (key) => (nameSpace = key);

export const getKey = (key) => `${nameSpace}-${key}`;

export const STORAGE_KEY = {
  DATA_ENTRY_ITEM_KEY: 'DATA_ENTRY_ITEM_KEY', // 标记保存
  TOKEN: 'TOKEN', // JWT TOKEN
  DEBUG_USER: 'DEBUG_USER', // ghostlogin用户
  UPLOAD_FILES: 'UPLOAD_FILES', // 上传的文件
  ACTIVE_GROUPS_IDS: 'ACTIVE_GROUPS_IDS', // set-permissions 保存选择的用户
  PERMISSION_TABLE: 'PERMISSION_TABLE', // 设置权限的表格数据
  USER_AGREEMENT: 'USER_AGREEMENT', // 该用户是否同意了用户协议
  PWD_ALERT: 'PWD_ALERT', // 用户是显示过设置密码弹窗
};

export const setLocal = (key, value, ignoreCheckKey = false) => {
  if (!STORAGE_KEY[key] && !ignoreCheckKey) {
    console.warn(`${key}在STORAGE_KEY中未声明，请在localStorage文件中声明`);
    return;
  }
  let stringVal;
  if (isObject(value) || isBoolean(value)) {
    stringVal = JSON.stringify(value);
  }
  if (isString(value)) {
    stringVal = value;
  }

  localStorage.setItem(getKey(key), stringVal);
};

export const getLocal = (key, defaultVal) => {
  const val = localStorage.getItem(getKey(key));
  if (isNull(val)) return defaultVal || val;
  try {
    const objValue = JSON.parse(val);
    return objValue;
  } catch (e) {
    return val || defaultVal;
  }
};

export const clearLocal = (key) => {
  localStorage.removeItem(getKey(key));
};
